require('./category/category.scss');
var Obscura = require('backbone.obscura');
var View = Backbone.Marionette.CompositeView.extend({
    template: require('./category/category.html'),
    className: 'fmcy-category-text-menu-list',
    childView: require('./sub-category'),
    childViewContainer: '.fmcy-category-sub-categories',
    childViewOptions: function (model, index) {
        return {
            category: this.model,
            collection: this.collection,
            appChannel: this.options.appChannel
        };
    },
    childEvents: {
        'subcat:clicked': 'onChildSubcatClicked'
    },
    ui: {
      categoryHeader : '.fmcy-category-header'
    },
    events: {
      'click @ui.categoryHeader': 'headerClicked'
    },
    serializeData: function() {
        return {
            category: this.model.toJSON()
        };
    },
    initialize: function () {
      var self = this;

      var orderedCollection = new Backbone.Collection();
      var subCatCollection = new Obscura(
          this.options.categories
      );

      // first level sub category
      subCatCollection.filterBy('parent_id', function(subModel) {
        if (subModel.get('parent_id') === self.model.get('id')) {
          subModel.set('level', 1);
          return true;
        } else {
          return false;
        }
      }).setSort('ordinal', 'asc');

      subCatCollection.each(function (model, index) {
        orderedCollection.add(model);
        // only supports one level deep...
        self.collection.each(function (childmodel) {
          if (childmodel.get('parent_id') !== null && childmodel.get('parent_id') == model.get('id')) {
            childmodel.set('level', 2);
            orderedCollection.add(childmodel);
          }
        })
      });

      var orderedCollectionObscura = new Obscura(
          orderedCollection
      );
      orderedCollectionObscura.setSort('ordinal', 'asc');

      this.collection = orderedCollectionObscura;
    },
    onChildSubcatClicked: function(childView) {
        this.trigger('category:clicked', childView.model);
    },
    headerClicked: function () {
        this.trigger('category:clicked', this.model);
    },
    getHeight: function () {
      return this.$el.height();
    }
});

module.exports = View;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/category-text-menu/category.js
 **/